<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 13V11H17V13H15Z" :fill="color" />
    <path d="M17 16V14H15V16H17Z" :fill="color" />
    <path d="M7 19V17H9V19H7Z" :fill="color" />
    <path d="M13 17H11V19H13V17Z" :fill="color" />
    <path d="M17 19V17H15V19H17Z" :fill="color" />
    <path d="M11 14H13V16H11V14Z" :fill="color" />
    <path d="M9 14H7V16H9V14Z" :fill="color" />
    <path d="M13 11H11V13H13V11Z" :fill="color" />
    <path d="M7 11H9V13H7V11Z" :fill="color" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18 3V1H16V3H8V1H6V3H4C2.89543 3 2 3.89543 2 5V21C2 22.1046 2.89543 23 4 23H20C21.1046 23 22 22.1046 22 21V5C22 3.89543 21.1046 3 20 3H18ZM20 5V7H4V5H20ZM4 21V9H20V21H4Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'CalendarOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
